// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u8Gz","newExpiryDate":"styles_newExpiryDate__6-cfi","footer":"styles_footer__1XE2J"};